// Already lazy — workspace index.tsx exports a lazy() default
import AddToCartPage from "@faire/prototype-playground/workspace/sc/add-to-cart";
import CartSeparateOrderMinsPage from "@faire/prototype-playground/workspace/sc/cart-separate-order-mins";
import FiltersPage from "@faire/prototype-playground/workspace/sc/filters";
import NextGenSearchPage from "@faire/prototype-playground/workspace/sc/next-gen-search";
import ProductTilesReviewsCountPage from "@faire/prototype-playground/workspace/sc/product-tiles-reviews-count";
import ReorderCarouselPage from "@faire/prototype-playground/workspace/sc/reorder-carousel";
import ReorderedProductsInTypeaheadPage from "@faire/prototype-playground/workspace/sc/reordered-products-typeahead";
import SearchRefinementPage from "@faire/prototype-playground/workspace/sc/search-refinement";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const FindSimilarPage = withCompass(
  () => import("../../pages/FindSimilarPage")
);
const ProductTilesPage = withCompass(
  () => import("../../pages/ProductTilesPage")
);
const SpaGiftsSearchPage = withCompass(
  () => import("../../pages/SpaGiftsSearchPage")
);
const MultiTurnSearchPage = withCompass(
  () => import("../../pages/MultiTurnSearchPage")
);
const ProductGridPage = withCompass(
  () => import("../../pages/ProductGridPage")
);
const SearchSplitGridResultsPage = withCompass(
  () => import("../../pages/SearchSplitGridResultsPage")
);

export function SamChiengRoutes() {
  return (
    <Switch>
      <Route path="/sc/add-to-cart" component={AddToCartPage} />
      <Route
        path="/sc/cart-separate-order-mins"
        component={CartSeparateOrderMinsPage}
      />
      <Route path="/sc/filters" component={FiltersPage} />
      <Route path="/sc/find-similar" component={FindSimilarPage} />
      <Route path="/sc/multi-turn-search" component={MultiTurnSearchPage} />
      <Route path="/sc/next-gen-search" component={NextGenSearchPage} />
      <Route path="/sc/pdp-mobile" component={ProductGridPage} />
      <Route exact path="/sc/product-tiles" component={ProductTilesPage} />
      <Route
        path="/sc/product-tiles-reviews-count"
        component={ProductTilesReviewsCountPage}
      />
      <Route path="/sc/reorder-carousel" component={ReorderCarouselPage} />
      <Route
        path="/sc/reordered-products-typeahead"
        component={ReorderedProductsInTypeaheadPage}
      />
      <Route
        exact
        path="/sc/search-refinement"
        component={SearchRefinementPage}
      />
      <Route
        path="/sc/search-refinement/find-similar"
        component={FindSimilarPage}
      />
      <Route
        path="/sc/search-refinement/spa-gifts"
        component={SpaGiftsSearchPage}
      />
      <Route
        exact
        path="/sc/search-split-grid-results"
        component={SearchSplitGridResultsPage}
      />
    </Switch>
  );
}

export const slug = "sc";
